module.exports = __webpack_public_path__ + "media/Video 92.fdc464b5.mp4";